import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'A type of assessment to gauge the overall health of an organization from a strategy perspective.',
    name: 'Health Check',
    partialId: PartialId.Standard.create('health-check'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
